'use client';

import { redirect } from 'next/navigation';

export default function PrivacyRedirect() {
  // Get the user's language from localStorage (default to 'ar')
  const language = localStorage.getItem('i18nextLng') || 'ar';

  // Redirect /privacy-policy → language-specific Privacy Policy page
  redirect(`/${language}/privacy-policy`);
}
